/**
 * const {time, synced, startDate, theWeek} = useCurrentDate();
 */
import { getCurrentTime } from "../service/exam";
import moment from "moment";
import { getCurrentDate, toNumber } from "../service/service";
import { storageAtom } from "./useStorage";
import Config from "../config";
import { useState } from "react";
import { useInterval } from "react-use";
import { atom } from "jotai";
import { useAtomValue } from "jotai";
import Storage from "./Storage";

const timeAtom = atom(async get => {
    const batchNo = get(
        storageAtom({
            key: "batch",
            initialValue: Storage.get("batch") || Config.DefaultBatch
        })
    );

    const resDatePromise = getCurrentDate();
    const resTimePromise = getCurrentTime();
    const resDate = await resDatePromise;
    const resTime = await resTimePromise;

    const serverTime = moment(resTime);
    const browserTime = moment();
    const offset = serverTime.diff(browserTime); // 毫秒
    const theWeek = Math.min(
        toNumber(resDate.theWeek),
        Config.MaxWeek
    ).toString();

    return {
        time: browserTime.add(offset),
        offset,
        theWeek,
        batchNo,
        endDate: resDate.endDate,
        startDate: resDate.startDate
    };
});

/**
 *
 * @param sync // 是否持续刷新时间
 */
export default function useCurrentDate() {
    return useAtomValue(timeAtom);
}

/**
 * 获取当前服务器时间, 并持续刷新
 */
export function useCurrentTimeSync() {
    const [count, setCount] = useState(0);
    const data = useCurrentDate();
    useInterval(() => setCount(count + 1), 300);

    return moment().add(data.offset);
}
